import type { SVGProps } from 'react';

const Svg2022UadTimeBasedMetadata = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M19 7v8c0 .55.45 1 1 1s1-.45 1-1V7c0-1.65-1.35-3-3-3H6C4.35 4 3 5.35 3 7v8c0 .55.45 1 1 1s1-.45 1-1V7c0-.55.45-1 1-1h12c.55 0 1 .45 1 1"
    />
    <path
      fill="currentcolor"
      d="M16 8H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1m0 4H8c-.55 0-1 .45-1 1s.45 1 1 1h8c.55 0 1-.45 1-1s-.45-1-1-1M5 18h-.72c-.55 0-1 .45-1 1s.45 1 1 1H5c.55 0 1-.45 1-1s-.45-1-1-1m15.28 0H17c-.55 0-1 .45-1 1s.45 1 1 1h3.28c.55 0 1-.45 1-1s-.45-1-1-1M14 17c-.55 0-1 .45-1 1H9c0-.55-.45-1-1-1s-1 .45-1 1v2c0 .55.45 1 1 1s1-.45 1-1h4c0 .55.45 1 1 1s1-.45 1-1v-2c0-.55-.45-1-1-1"
    />
  </svg>
);
export default Svg2022UadTimeBasedMetadata;
